import { Controller } from "stimulus"

// Animates a number counting up from startValue to endValue
export default class extends Controller {
  static values = {
    start: Number,
    end: Number,
    duration: Number
  }

  connect() {
    this.animate()
  }

  animate() {
    const startValue = this.startValue
    const endValue = this.endValue
    const duration = this.durationValue || 1000
    const startTime = performance.now()

    const updateCount = (currentTime) => {
      const elapsed = currentTime - startTime
      const progress = Math.min(elapsed / duration, 1)

      // Ease out cubic for smooth deceleration
      const easeOut = 1 - Math.pow(1 - progress, 3)
      const currentValue = Math.round(startValue + (endValue - startValue) * easeOut)

      this.element.textContent = currentValue

      if (progress < 1) {
        requestAnimationFrame(updateCount)
      } else {
        this.element.textContent = endValue
      }
    }

    requestAnimationFrame(updateCount)
  }
}
